import { render, staticRenderFns } from "./c-json-treeview.vue?vue&type=template&id=c8863d40&"
import script from "./c-json-treeview.vue?vue&type=script&lang=js&"
export * from "./c-json-treeview.vue?vue&type=script&lang=js&"
import style0 from "./c-json-treeview.vue?vue&type=style&index=0&id=c8863d40&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports